<div class="row bloccodati">
	<!--*ngIf="fascicolo.tipoFascicolo.label != 'DIBATTIMENTO' && fascicolo.tipoFascicolo.label != 'INDAGINI PRELIMINARI'"-->
	<div labelTextInput class="col-sm-3" [typeLabel]="'text'" [labelInput]="'Tipo fascicolo'"
		[valueInput]="fascicolo.tipoFascicolo ? fascicolo.tipoFascicolo.label : labelCreatoDaSistema"></div>
	<div labelTextInput class="col-sm-3"  [typeLabel]="'text'" [labelInput]="'Posizione'"
		[valueInput]="fascicolo.posizione ? fascicolo.posizione : labelCreatoDaSistema"></div>
	<div labelTextInput class="col-sm-3"  [typeLabel]="'text'" [labelInput]="'Vecchia posizione'"
		[valueInput]="fascicolo.vecchiaPosizione ? fascicolo.vecchiaPosizione : ''"></div>
	<div labelTextInput class="col-sm-3"  [typeLabel]="'text'" [labelInput]="'Stato'"
		[valueInput]="fascicolo.stato ? fascicolo.stato.label : labelCreatoDaSistema"></div>
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Visibilit&agrave;'"
  [valueInput]="fascicolo.tipoVisibilita ? fascicolo.tipoVisibilita.label : 'Ereditata dalla pratica'"></div>
	<!--*ngIf="fascicolo.tipoFascicolo.label != 'DIBATTIMENTO' && fascicolo.tipoFascicolo.label != 'INDAGINI PRELIMINARI' && fascicolo.tipoFascicolo.label != 'AMIANTO STRAGIUDIZIALE'  && fascicolo.tipoFascicolo.label != 'AMIANTO'"-->
	<div labelTextInput class="col-sm-4" [typeLabel]="'date'" [labelInput]="'Data apertura'"
		[valueInput]="fascicolo.dataInizioFascicolo"></div>
	<div labelTextInput class="col-sm-4" [typeLabel]="'date'" [labelInput]="'Data notifica'"
		[valueInput]="fascicolo.dataNotifica"></div>
	<!--<div labelTextInput class="col-sm-2" [typeLabel]="'date'"
		[labelInput]="'Data variazione'" [valueInput]="fascicolo.dataVariazioneFondoRischi"></div>-->
</div>

<div class="row bloccodati" *ngIf="!isSchedaAnalitica && (fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' || fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE')">
	<div *ngIf="fascicolo.praticaBase.tipoPratica.descrizione === 'CIVILE' || fascicolo.praticaBase.tipoPratica.descrizione === 'LAVORO'" labelTextInput class="col-sm-6" [typeLabel]="'date'" [labelInput]="'Data prima comparizione'"
		[valueInput]="fascicolo.dataPrimaComparizione"></div>
	<div *ngIf="fascicolo.praticaBase.tipoPratica.descrizione === 'TRIBUTARIO' || fascicolo.praticaBase.tipoPratica.descrizione === 'AMMINISTRATIVO'"
		labelTextInput class="col-sm-6" [typeLabel]="'date'" [labelInput]="'Data deposito ricorso'"
		[valueInput]="fascicolo.dataDepositoRicorso">
	</div>
</div>

<div class="row bloccodati" *ngIf="isSchedaAnalitica && (fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' || fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE')">
	<div *ngIf="pratica?.tipoPratica.descrizione === 'CIVILE' || pratica?.tipoPratica.descrizione === 'LAVORO'" labelTextInput class="col-sm-6" [typeLabel]="'date'" [labelInput]="'Data prima comparizione'"
		[valueInput]="fascicolo.dataPrimaComparizione"></div>
	<div *ngIf="pratica?.tipoPratica.descrizione === 'TRIBUTARIO' || pratica?.tipoPratica.descrizione === 'AMMINISTRATIVO'"
		labelTextInput class="col-sm-6" [typeLabel]="'date'" [labelInput]="'Data deposito ricorso'"
		[valueInput]="fascicolo.dataDepositoRicorso">
	</div>
</div>

<div class="row bloccodati" *ngIf="fascicolo && (fascicolo.tipoFascicolo.categoria.id != 'CONSULENZA')">
	<div labelTextInput class="col-sm-6" [typeLabel]="'text'" [labelInput]="'Natura'"
		[valueInput]="fascicolo.natura?.descrizione"></div>
	<div labelTextInput class="col-sm-6" [typeLabel]="'boolean'" [labelInput]="'Fondo rischi'"
		[valueInput]="fascicolo.flagFondoRischi"></div>
	<!--<div labelTextInput class="col-sm-4" [typeLabel]="'boolean'" [labelInput]="'Recupero crediti'"
		[valueInput]="fascicolo.recuperoCrediti"></div>-->
</div>
<!-- <div *ngIf="fascicolo.vecchiaPosizione" class="row bloccodati">
	<div labelTextInput class="col-sm-6" [typeLabel]="'text'" [labelInput]="'Posizione Fisica'"
		[valueInput]="fascicolo.vecchiaPosizione? fascicolo.vecchiaPosizione : '' "></div>

</div> -->
<!--<div class="row bloccodati" *ngIf="fascicolo.tipoFascicolo.label === 'DIBATTIMENTO' || fascicolo.tipoFascicolo.label === 'INDAGINI PRELIMINARI'">
	<div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Tipo fascicolo'"
		[valueInput]="fascicolo.tipoFascicolo ? fascicolo.tipoFascicolo.label : labelCreatoDaSistema"></div>
	<div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Posizione'"
		[valueInput]="fascicolo.posizione ? fascicolo.posizione : labelCreatoDaSistema"></div>
	<div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Stato'"
		[valueInput]="fascicolo.stato ? fascicolo.stato.label : labelCreatoDaSistema"></div>
	<div labelTextInput class="col-sm-6" [typeLabel]="'date'"
		[labelInput]="'Data apertura'" [valueInput]="fascicolo.dataInizioFascicolo"></div>
	<div labelTextInput class="col-sm-6" [typeLabel]="'boolean'"
		[labelInput]="'Recupero crediti'" [valueInput]="fascicolo.recuperoCrediti"></div>
</div>-->
<ng-template [ngIf]="!isSchedaAnalitica">
	<div class="row bloccodati" *ngIf="fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE' || fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' && fascicolo.praticaBase.tipoPratica.descrizione != 'PARERISTICO'">
		<div labelTextInput class="col-sm-4 bloccodati"
			[typeLabel]="'boolean'" [labelInput]="'Costituzione'"
			[valueInput]="fascicolo.flagCostituzione">
		</div>

		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Motivazione'"
			[valueInput]="fascicolo?.motivazione?.label">
		</div>

		<div labelTextInput class="col-sm-4 bloccodati"
			[typeLabel]="'date'" [labelInput]="'Data costituzione'"
			[valueInput]="fascicolo.dataCostituzione">
		</div>
	</div>
</ng-template>
<ng-template [ngIf]="isSchedaAnalitica">
	<div class="row bloccodati" *ngIf="(fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE' || fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE') && pratica?.tipoPratica.descrizione != 'PARERISTICO'">
		<div labelTextInput class="col-sm-4 bloccodati"
			[typeLabel]="'boolean'" [labelInput]="'Costituzione'"
			[valueInput]="fascicolo.flagCostituzione">
		</div>

		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Motivazione'"
			[valueInput]="fascicolo?.motivazione?.label">
		</div>

		<div labelTextInput class="col-sm-4 bloccodati"
			[typeLabel]="'date'" [labelInput]="'Data costituzione'"
			[valueInput]="fascicolo.dataCostituzione">
		</div>
	</div>
</ng-template>

<div class="row">
	<div class="col-sm-12 bloccodati">
	  <p>
		<label class="col-sm-12" style="padding-left: unset;">Descrizione oggetto</label>
		<span class="longtext">{{ fascicolo.descrizioneOggetto }}</span>
	  </p>
	</div>
</div>
<div class="row" *ngIf="fascicolo.tipoFascicolo.endpoint === 'genericogiudiziale'">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		 [labelInput]="'Tipologia'"
		 [valueInput]="fascicolo.tipologiaGenericoGiudiziale ? (fascicolo.tipologiaGenericoGiudiziale.label || fascicolo.tipologiaGenericoGiudiziale) : ''"></div>
</div>
<div class="row container_fieldset" *ngIf="fascicolo.tipoFascicolo.categoria.id === 'GIUDIZIALE' || fascicolo.tipoFascicolo.categoria.id === 'ESECUZIONE'">
	<div class="col-sm-12">
		<fieldset class="form-group">
			<legend>Dati giudiziari</legend>
			<div class="row" style="margin: 0 0.5px 0 0.5px;">
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Autorit&agrave; Giudiziaria'"
					[valueInput]="fascicolo.autoritaGiudiziaria?.descrizione"></div>
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Sede'"
					[valueInput]="fascicolo.autoritaGiudiziariaCitta?.label ? fascicolo.autoritaGiudiziariaCitta?.label : fascicolo.sedeAutorita?.label"></div>
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Grado'"
					[valueInput]="fascicolo.grado ? fascicolo.grado.label : ''"></div>
			</div>
			<div class="row" style="margin: 0 0.5px 0 0.5px;">
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Numero/Anno ruolo'"
					[valueInput]="(fascicolo.numeroRuolo ? fascicolo.numeroRuolo : '')  + ((fascicolo.annoRuolo && fascicolo.numeroRuolo) ? '/' : '') + (fascicolo.annoRuolo ? fascicolo.annoRuolo : '')">
				</div>
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Sezione'"
					[valueInput]="fascicolo.sezione"></div>
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Giudice'"
					[valueInput]="fascicolo.giudice"></div>
			</div>

		</fieldset>
	</div>
</div>
<div class="row container_fieldset" *ngIf="isProtocolEnabled && (fascicolo?.numeroProtocollo || fascicolo?.oggettoProtocollo || fascicolo?.dataProtocollazione)">
	<div class="col-sm-12">
		<fieldset class="form-group">
			<legend>Dati Protocollazione</legend>
			<div class="row" style="margin: 0 0.5px 0 0.5px;">
				<!-- <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'N° fascicolo'"
					[valueInput]="fascicolo.numeroFascicoloProtocollo ? fascicolo.numeroFascicoloProtocollo:''"></div> -->
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Numero protocollo'"
					[valueInput]="(fascicolo.numeroProtocollo ? fascicolo.numeroProtocollo : '') + (fascicolo.annoProtocollazione ? '/' + fascicolo.annoProtocollazione : '')"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Utente protocollatore'"
					[valueInput]="fascicolo.utenteProtocollatore ? fascicolo.utenteProtocollatore : ''"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Data protocollazione'"
					[valueInput]="fascicolo.dataProtocollazione ? fascicolo.dataProtocollazione : ''"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Registrazione'"
					[valueInput]="fascicolo.inUscita ? 'IN USCITA' : 'IN ENTRATA'"></div>
				<div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'textarea'" [labelInput]="'Mittente / Destinatario'"
					[valueInput]="fascicolo.senderReceiver"></div>
			  </div>
			<div class="row" style="margin: 0 0.5px 0 0.5px;">
				<div class="col-sm-12 bloccodati">
					<p>
						<label>Oggetto</label>
						<span class="longtext">{{ fascicolo.oggettoProtocollo ? fascicolo.oggettoProtocollo : '' }}</span>
					</p>
				</div>
			</div>
		</fieldset>
	</div>
</div>
<div *ngIf="fascicolo.definito" class="row container_fieldset bloccodati">
	<div class="col-sm-12">
		<fieldset class="form-group">
			<legend>Definizione fascicolo</legend>
			<div labelTextInput class="col-sm-4" [typeLabel]="'boolean'" [labelInput]="'Definito'"
				[valueInput]="fascicolo.definito"></div>
			<div labelTextInput class="col-sm-4" [typeLabel]="'date'" [labelInput]="'Data definizione'"
				[valueInput]="fascicolo.dataDefinizione"></div>
			<div labelTextInput class="col-sm-4" [typeLabel]="'text'" [labelInput]="'Motivo definizione'"
				[valueInput]="fascicolo.motivoDefinizione.label"></div>
		</fieldset>
	</div>
</div>
